import {
  ARBITRATOR_FORM_LOADER,
  ARBITRATOR_FORM_SUBMITTED,
} from "../actionTypes";

const initialState = {
  loader: false,
  submitted: false,
};

const arbitratorFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARBITRATOR_FORM_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case ARBITRATOR_FORM_SUBMITTED: {
      return {
        ...state,
        submitted: action.payload,
      };
    }
    default:
      return state;
  }
};

export default arbitratorFormReducer;
